<template>
    <div style="padding: 20px;width: 100%;height: 100%">
        <div style="display: flex;align-items: center">
            <img src="../../../assets/img/icon.png" alt="" style="width: 24px;margin:0px 5px">
            <h3>合同累计签署量</h3>
        </div>
        <div class="numBox">
            <img src="../../../assets/img/china.png" alt="">
            <div>
                <p>合同总数量：{{allData.contract_total_num}}份</p>
                <p>已用数量：{{allData.used_contract_num}}份</p>
                <p>剩余数量：{{allData.contract_num}}份</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'signNum',
    props:['allData'],
    data(){
        return{

        }
    }
}

</script>

<style scoped lang="scss">
h3{
    --c: #008CFF;
    color: #acd3ec !important;
    text-shadow: 0 0 10px var(--c);
}
.numBox{
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: space-between;
    img{
        width: 65%;
        height: 100%;
    }
    div{
        padding: 5px;
        border-radius: 5px;
        border: 1px solid #475EA8;
        height: 30%;
        color: #acd3ec;
    }
}

</style>